/**
 * CMCD v2 - Response-only and timing keys.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_RESPONSE_KEYS = [
	'cmsdd',
	'cmsds',
	'rc',
	'smrt',
	'ttfb',
	'ttfbb',
	'ttlb',
	'url',
] as const;
